import { createSlice } from "@reduxjs/toolkit";

const advSearchList = createSlice({
    name: "advanceSearchList",
    initialState: {
        toiletName: "",
        deviceName: "",
        deviceId: "",
        hierarchyNode: "",
        advSearchFlag: false,
        isAdvSearchedFilterDataEmpty: false,
        online: false,
        offline: false
    },
    reducers: {
        appendAdvSearchList: (state, action) => {
            const { toiletName, deviceName, deviceId, hierarchyNode, online, offline } = action.payload;

            state.toiletName = toiletName;
            state.deviceName = deviceName;
            state.deviceId = deviceId;
            state.hierarchyNode = hierarchyNode;
            state.online = online;
            state.offline = offline;
        },

        clearAdvSearchList: (state) => {
            state.toiletName = "";
            state.deviceName = "";
            state.deviceId = "";
            state.hierarchyNode = "";
            state.online = false;
            state.offline = false;
        },

        updateAdvSearchFlag: (state, action) => {
            state.advSearchFlag = action.payload;
        },

        updateIsAdvSearchedFilterDataEmpty: (state, action) => {
            state.isAdvSearchedFilterDataEmpty = action.payload;
        }
    }
});

export const { appendAdvSearchList, clearAdvSearchList, updateAdvSearchFlag, updateIsAdvSearchedFilterDataEmpty } = advSearchList.actions;

export default advSearchList.reducer;